module.exports = __webpack_public_path__ + "img/meal-equation.d4a2f1e6.svg";